const backend_url =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8080";

export const config = {
  backend_url: `${backend_url}`,
};
